import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
		css: {
			type: String,
			default: "w-20",
		},
	},
  setup(__props) {

	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: "/media/logos/Logo-Jahagal.svg",
    class: _normalizeClass([__props.css])
  }, null, 2))
}
}

})